// store/userSitesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSites } from '../pages/api/api';

// Define the initial state
const initialState = {
  userSites: [],
  status: 'idle', // status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Define the thunk for fetching userSites
export const fetchUserSites = createAsyncThunk(
  'userSites/fetchUserSites',
  async (_, thunkAPI) => {
    try {
      const response = await getSites()
    //   console.debug("RES{", response.json())
    //   if (!response.ok) {
    //     throw new Error('Error fetching userSites');
    //   }
      // console.debug("RES{---", response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const userSitesSlice = createSlice({
  name: 'userSites',
  initialState,
  reducers: {
    setSitesState: (state, action) => {
      state.userSites = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserSites.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserSites.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userSites = action.payload;
      })
      .addCase(fetchUserSites.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setSitesState } = userSitesSlice.actions;
export default userSitesSlice.reducer;
